module.exports = __webpack_public_path__ + "static/rhi-logo-bath-662048d92f29a6bd8c0f7786bda79a8a.png";